import { useRef, useState } from 'react';

import styled from '@emotion/styled';
import { DropdownMenu2, IconButtonGhost, Tooltip } from '@kc-console/common-ui';
import { useScopedLinkBuilder } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';
import { IcClockRegular } from '@kep/kcds-icons';

import { useRefinedRecentServiceState } from '../../../../hooks';
import { getRecentLnbItemButtonStyle } from '../styled';

import type { DropdownMenu2Props } from '@kc-console/common-ui';

export default function RecentMenuSection() {
  const { t } = useTranslation();
  const { recentServices } = useRefinedRecentServiceState();
  const { getProps } = useScopedLinkBuilder();
  const [isOpenRecentMenu, setIsOpenRecentMenu] = useState<boolean>(false);
  const ref = useRef(null);

  // TODO(navigation): DropdownMenu2 가 anchor item 을 지원하도록 개선되면 isAnchor 옵션 제거하고
  //   href 로 전환. 현재 isAnchor:false 는 ctrl/cmd+click 새 탭만 emulate 하며
  //   shift→새 창, alt→다운로드, middle-click 은 지원하지 못한다.
  const dropDownMenuItems: DropdownMenu2Props['items'] = [
    {
      type: 'section',
      title: t('layout:lnb.recent.title'),
      items: recentServices.map(({ name, path }) => {
        const { onClick } = getProps(path, { isAnchor: false });
        return {
          text: name,
          onClick: event => onClick(event),
        };
      }),
    },
  ];

  return (
    <RecentMenuSectionContainer ref={ref}>
      <Tooltip message={t('layout:lnb.recent.title')} placement={'right'}>
        <RecentMenuIconButton onClick={() => setIsOpenRecentMenu(!isOpenRecentMenu)}>
          <IcClockRegular />
        </RecentMenuIconButton>
      </Tooltip>
      {isOpenRecentMenu && (
        <DropdownMenu2
          open={isOpenRecentMenu}
          onClose={() => setIsOpenRecentMenu(false)}
          anchorEl={ref.current}
          items={dropDownMenuItems}
        />
      )}
    </RecentMenuSectionContainer>
  );
}

const RecentMenuIconButton = styled(IconButtonGhost)`
  width: 100%;
  height: 48px;
  padding: 0;
  border-radius: 0;
  font-size: 20px;
  color: ${({ theme }) => theme.color['icon/weaker/default']};

  ${({ theme }) => getRecentLnbItemButtonStyle(theme, { collapsed: true })};
`;

const RecentMenuSectionContainer = styled.div`
  display: flex;
`;
